<!--
  Layout C, viewer first: the library stays underneath, and opening anything takes the whole
  screen as a dark viewer with a filmstrip, closer to a photo app. Details, Edit set and compare
  are panels over the picture; capture is a sheet over the library.
-->
<template>
  <div class="md-vf">
    <MediaLibrary v-on="nav.on.library" />

    <div v-if="immersive" class="md-overlay md-vf-stage">
      <MediaCompare v-if="nav.view === 'compare'" layout="immersive" :ids="nav.pair" :back-label="nav.backLabel" v-on="nav.on.compare" />
      <template v-else>
        <MediaSetView layout="immersive" :context="viewerContext" :back-label="nav.view === 'edit' ? '' : nav.backLabel" v-on="nav.on.viewer" />
        <MediaSetEditor v-if="nav.view === 'edit' && nav.setId" layout="immersive" :set-id="nav.setId" :back-label="nav.backLabel" v-on="nav.on.editor" />
      </template>
    </div>

    <div v-if="nav.view === 'capture'" class="md-overlay" @click.self="nav.back()">
      <MediaCaptureFlow layout="sheet" :as-note="nav.asNote" :patient-uid="store.patientUid" back-label="Close" v-on="nav.on.capture" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useMediaStore } from '@/stores/mediaStore';
import MediaLibrary from './MediaLibrary.vue';
import MediaSetView from './MediaSetView.vue';
import MediaCompare from './MediaCompare.vue';
import MediaSetEditor from './MediaSetEditor.vue';
import MediaCaptureFlow from './MediaCaptureFlow.vue';

const props = defineProps({ nav: { type: Object, required: true } });
const store = useMediaStore();
const immersive = computed(() => props.nav.isViewer || props.nav.view === 'compare' || (props.nav.view === 'edit' && props.nav.setId));
// Edit set opens over the set it edits.
const viewerContext = computed(() => (props.nav.view === 'edit' ? { kind: 'set', setId: props.nav.setId } : props.nav.viewerContext));
</script>

<style scoped>
.md-proto .md-vf-stage { background:#0d1417; padding:0; align-items:stretch; justify-content:stretch; }
.md-vf-stage > * { flex:1 1 auto; min-width:0; }
</style>
